/**
 * Grail27 — Judge.me lightweight loader.
 * - Disables Judge.me review popups (Grail trust popup is used on PDP).
 * - Lazy-reveals below-fold carousels / medals when user scrolls near them.
 * Does not remove judgeme_core (required for homepage/collection widgets).
 */
(function () {
  'use strict';

  var POPUP_KEYS = [
    'popup_widget_show_on_product_page',
    'popup_widget_show_on_home_page',
    'popup_widget_show_on_collection_page',
    'popup_widget_show_on_cart_page',
  ];

  var LAZY_ROOT_SELECTORS = [
    '.jdgm-carousel-wrapper',
    '.jdgm-cards-wrapper',
    '.jdgm-medals-wrapper',
  ];

  function patchPopupSettings() {
    if (!window.jdgmSettings) return false;
    POPUP_KEYS.forEach(function (key) {
      window.jdgmSettings[key] = false;
    });
    return true;
  }

  function hideJudgemePopups() {
    document.querySelectorAll('.jdgm-review-snippet-popup, .jdgm-popup-widget').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function initWidgetsIfReady() {
    if (typeof window.jdgm !== 'undefined' && typeof window.jdgm.initializeWidgets === 'function') {
      window.jdgm.initializeWidgets();
    }
  }

  function lazyLoadWidgets() {
    var roots = [];
    LAZY_ROOT_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        roots.push(el);
      });
    });

    if (!roots.length) return;

    var viewportBuffer = 320;

    function reveal(root) {
      root.classList.remove('grail-jdgm-lazy-pending');
      root.classList.add('grail-jdgm-lazy-ready');
      initWidgetsIfReady();
    }

    if (!('IntersectionObserver' in window)) {
      roots.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          reveal(entry.target);
        });
      },
      { rootMargin: viewportBuffer + 'px 0px', threshold: 0.01 }
    );

    roots.forEach(function (root) {
      var top = root.getBoundingClientRect().top;
      if (top < window.innerHeight + viewportBuffer) {
        reveal(root);
        return;
      }
      root.classList.add('grail-jdgm-lazy-pending');
      io.observe(root);
    });
  }

  function getShopReviewCount() {
    var carrier = document.getElementById('grail-jm-shop-count');
    if (carrier) {
      var fromCarrier = parseInt(carrier.getAttribute('data-count'), 10);
      if (fromCarrier > 0) return fromCarrier;
    }

    var carouselCount = document.querySelector('.jdgm-carousel-number-of-reviews[data-number-of-reviews]');
    if (carouselCount) {
      var fromCarousel = parseInt(carouselCount.getAttribute('data-number-of-reviews'), 10);
      if (fromCarousel > 0) return fromCarousel;
    }

    var nodes = document.querySelectorAll(
      '.jdgm-all-reviews-text__text[data-number-of-reviews], .jdgm-all-reviews-rating[data-number-of-reviews]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var fromNode = parseInt(nodes[i].getAttribute('data-number-of-reviews'), 10);
      if (fromNode > 0) return fromNode;
    }

    return 0;
  }

  function fillTrustLineReviewCounts() {
    /* Liquid already printed a count. Swapping digits after paint reflows the
       above-fold trust line (CLS). Only fill nodes that are still empty. */
    var countNodes = document.querySelectorAll('[data-grail-trust-count]');
    if (!countNodes.length) return;

    var needsFill = false;
    countNodes.forEach(function (el) {
      if (!el.textContent.trim()) needsFill = true;
    });
    if (!needsFill) return;

    function apply(count) {
      if (!count || count < 1) return false;
      var label = String(count);
      countNodes.forEach(function (el) {
        if (!el.textContent.trim()) el.textContent = label;
      });
      return true;
    }

    if (apply(getShopReviewCount())) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (apply(getShopReviewCount()) || tries >= 24) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  function start() {
    if (!patchPopupSettings()) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        if (patchPopupSettings() || ++attempts > 100) {
          window.clearInterval(timer);
        }
      }, 50);
    }

    hideJudgemePopups();
    fillTrustLineReviewCounts();
    lazyLoadWidgets();

    window.setTimeout(hideJudgemePopups, 1500);
    window.setTimeout(hideJudgemePopups, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
